export const localStoragePrefix = "diwan-";
